import { createAction } from '@reduxjs/toolkit';
import { showNotificationAsync } from '../notifications/actions';
import { selectCategoryCollectionLoading } from './selectors';
import * as categoriesService from './service';
import type { CategoryDataModel } from './types';
import type { RootState } from '../store';
import type { AnyAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';

export const setCategoryRecords = createAction<CategoryDataModel[]>(
    '@@categories/SET_CATEGORY_RECORDS',
);

export const setCategoryCollection = createAction<{
    identifiers: Array<CategoryDataModel['id']>;
    namespace: string;
}>('@@categories/SET_CATEGORY_COLLECTION');

export const setCategoryCollectionLoading = createAction<{
    isLoading: boolean;
    namespace: string;
}>('@@categories/SET_CATEGORIES_LOADING');

export function loadCategoriesAsync(
    namespace: string,
): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch, getState) => {
        const isLoading = selectCategoryCollectionLoading(getState(), namespace);

        if (isLoading) {
            return;
        }

        dispatch(setCategoryCollectionLoading({ namespace, isLoading: true }));

        try {
            const response = await categoriesService.loadCategories();

            dispatch(setCategoryRecords(response.records.categories));
            dispatch(setCategoryCollection({ namespace, identifiers: response.categories }));
        } catch (error) {
            dispatch(showNotificationAsync('Не удалось загрузить данные'));
        }

        dispatch(setCategoryCollectionLoading({ namespace, isLoading: false }));
    };
}
